import { ApiClient, extractPagination } from './api-client';
import type { ApiResponse, PaginationMeta } from '../types';

export interface ReviewItem {
  id: string;
  rating: number;
  comment: string | null;
  authorFirstName: string;
  authorLastInitial: string;
  createdAt: string;
}

export interface ReviewSummary {
  average: number;
  count: number;
  /** Counts per star, index 0 → 1-star, index 4 → 5-star. */
  distribution: number[];
}

export interface CreateReviewPayload {
  bookingId: string;
  rating: number;
  comment?: string;
}

export const reviewsService = {
  summary: async (providerId: string): Promise<ReviewSummary> =>
    (await ApiClient.get<ReviewSummary>(`/providers/${providerId}/reviews/summary`)).data,

  list: async (
    providerId: string,
    page = 0,
    size = 10,
  ): Promise<{ items: ReviewItem[]; pagination: PaginationMeta }> => {
    const res = await ApiClient.get<ReviewItem[], { page: number; size: number }>(
      `/providers/${providerId}/reviews`,
      { page, size },
    );
    return {
      items: res.data,
      pagination: extractPagination(res as ApiResponse<ReviewItem[]>),
    };
  },

  create: async (providerId: string, payload: CreateReviewPayload): Promise<ReviewItem> =>
    (await ApiClient.post<ReviewItem>(`/providers/${providerId}/reviews`, payload)).data,
};
